import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #d1d5db",
  borderRadius: 6,
  outline: "none",
  fontSize: 14,
};

export default function Login() {
  const [username, setUsername] = useState("user1");
  const [password, setPassword] = useState("parola123");
  const [role, setRole] = useState("frontdesk"); // 🔹 adăugat
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      const data: any = await api("/api/auth/login", {
        method: "POST",
        body: JSON.stringify({ username, password, role }),
      });

      const token = data.token ?? data.Token;
      localStorage.setItem("token", token);
      localStorage.setItem("role", role); // 🔹 memorăm rolul local
      localStorage.setItem("username", username); // <— AICI
      localStorage.setItem("userId", data.userId);

      // 🔹 redirecționare în funcție de rol
      if (role === "backoffice") navigate("/backoffice", { replace: true });
      else navigate("/dashboard", { replace: true });
    } catch (err: any) {
      setError(err.message || "Login failed");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f9fafb",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "48px 40px",
          borderRadius: 12,
          width: "100%",
          maxWidth: 400,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img
            src="logos/hotelvpf-logo.png"
            style={{ width: 90, height: "auto", marginBottom: 8 }}
            loading="lazy"
            onError={(e) =>
              (e.currentTarget.src = "/logos/hotelvpf-tran-logo.png")
            }
            alt="HotelVPF Logo"
            className="h-16 mx-auto mb-3"
          />
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#111827" }}>
            Sign in to HotelVPF
          </h1>
          <p style={{ fontSize: 13, color: "#9ca3af", marginTop: 2 }}>
            Trusted by hotels worldwide 🌍
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <input
            style={inputStyle}
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
          />
          <input
            type="password"
            style={{ ...inputStyle, marginTop: 14 }}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />

          {/* 🔹 radio buttons pentru rol */}
          <div style={{ marginTop: 16, marginBottom: 8, textAlign: "center" }}>
            <label style={{ marginRight: 16 }}>
              <input
                type="radio"
                value="frontdesk"
                checked={role === "frontdesk"}
                onChange={(e) => setRole(e.target.value)}
              />{" "}
              Front Desk
            </label>
            <label>
              <input
                type="radio"
                value="backoffice"
                checked={role === "backoffice"}
                onChange={(e) => setRole(e.target.value)}
              />{" "}
              Back Office
            </label>
          </div>

          {error && (
            <p style={{ color: "#b91c1c", fontSize: 13, marginTop: 8 }}>
              {error}
            </p>
          )}

          <button
            style={{
              width: "100%",
              marginTop: 16,
              padding: "12px 16px",
              background: "#2563eb",
              color: "white",
              border: "none",
              borderRadius: 8,
              fontWeight: 600,
              cursor: "pointer",
              fontSize: 15,
            }}
          >
            Sign in
          </button>
        </form>

        <div style={{ marginTop: 28, textAlign: "center" }}>
          <span style={{ color: "#6b7280", fontSize: 14 }}>
            New to HotelVPF?{" "}
          </span>
          <a
            href="#"
            style={{
              color: "#2563eb",
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.preventDefault();
              navigate("/register");
            }}
          >
            Create an account →
          </a>
        </div>
      </div>
    </div>
  );
}
